// extracted by mini-css-extract-plugin
module.exports = {"completedIconContainer":"Completed_completedIconContainer__6zGUS","completedIcon":"Completed_completedIcon__g1GdD"};